module.exports = __webpack_public_path__ + "img/dot_square.5db5f355.svg";